// eslint-disable  prefer-arrow/prefer-arrow-functions
import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { QuoteSession } from '@models/QuoteSession';

export function createInititalState(): Partial<QuoteSession> {
	return {
		contact: {
			ratingZipCode: '',
			emailAddress: '',
			phoneNumber: '',
			organizationCode: '',
			organizationMemberIdentifier: '',
			optInTextMessage: false,
			heardAboutUs: 0,
			firstName: '',
			lastName: '',
			partnerSenderId: '',
			brand: '',
			mailingAddress: undefined,
			billingInformation: {},
		},
		pets: [
			{
				name: '',
				species: undefined,
				gender: undefined,
				breedId: '',
				breedName: '',
				ageInYears: '',
				isServiceDog: false
			},
		],
		analyticsInfo: {},
		delayPolicyStartDateDays: 0,
		subProducerNumber: undefined,
	};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'quoteStore', resettable: true })
export class QuoteStore extends Store<Partial<QuoteSession>> {
	constructor() {
		super(createInititalState());
	}
}
